/**
 * FAQ Interfaces
 * Type definitions for FAQ management
 */

/**
 * FAQ Item
 */
export interface FaqItem {
  id: number;
  question: string;
  answer: string;
  sequence: number;
  lang: string;
  lang_name: string;
  status?: number;
}

/**
 * API Response for FAQ List
 */
export interface FaqListApiResponse {
  data: FaqItem[];
}

/**
 * Language Item
 */
export interface LanguageItem {
  id: number;
  lang_name: string;
  short_name: string;
  status?: number;
}

/**
 * API Response for Language List
 */
export interface LanguageListApiResponse {
  data: LanguageItem[];
}

/**
 * FAQ Form Data (Create)
 */
export interface FaqCreatePayload {
  ques: string;
  ans: string;
  sequence: number;
  lang: string;
}

/**
 * FAQ Form Data (Update)
 */
export interface FaqUpdatePayload extends FaqCreatePayload {
  id: number;
}

/**
 * API Response for Create/Update FAQ
 */
export interface FaqMutationApiResponse {
  body: {
    data: {
      message: string;
    };
  };
}
